import { render, staticRenderFns } from "./createWxFuwuOrder.vue?vue&type=template&id=0bf1ee5d&scoped=true"
import script from "./createWxFuwuOrder.vue?vue&type=script&lang=js"
export * from "./createWxFuwuOrder.vue?vue&type=script&lang=js"
import style0 from "./createWxFuwuOrder.vue?vue&type=style&index=0&id=0bf1ee5d&prod&scoped=true&lang=css"
import style1 from "./createWxFuwuOrder.vue?vue&type=style&index=1&id=0bf1ee5d&prod&lang=css"
import style2 from "./createWxFuwuOrder.vue?vue&type=style&index=2&id=0bf1ee5d&prod&scoped=true&lang=scss"
import style3 from "./createWxFuwuOrder.vue?vue&type=style&index=3&id=0bf1ee5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf1ee5d",
  null
  
)

export default component.exports